import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { countries } from './countries';

export interface Country {
    code: string;
    name: string;
}

@Injectable({
    providedIn: 'root',
})
export class CountryService {
    public resellerCountry: string;
    public countrySelected: string = 'none';

    constructor() {
        this.setCountry(this.countrySelected);
    }

    getCountries(): Country[] {
        return countries;
    }

    // getAmazonCountries(): Country[] {
    //     if (!this.amazonDspService.amazonDspAllowedCountries || this.amazonDspService.amazonDspAllowedCountries.length == 0) return;
    //     let amzCountries: Country[] = [];

    //     let allowedCountries: string[] = this.amazonDspService.amazonDspAllowedCountries.split(';');
    //     for (let i = 0; i < allowedCountries.length; i++) {
    //         let element = allowedCountries[i];
    //         if (!countries.find((x) => x.code == element)) continue;
    //         else {
    //             let country: Country = countries.find((x) => x.code == element);

    //             if (!amzCountries.find((x) => x.code == element)) {
    //                 amzCountries.push(country);
    //             }
    //         }
    //     }

    //     return amzCountries;
    // }
    public setResellerCountry(resellerCountry: string) {
        this.resellerCountry = resellerCountry;
    }

    public getResellerCountry() {
        let selectedCountry: Country[] = [];

        if (!countries.find((x) => x.code == this.resellerCountry)) return countries;
        else {
            let country: Country = countries.find((x) => x.code == this.resellerCountry);
            if (country) selectedCountry.push(country);
        }
        return selectedCountry;
    }

    public setCountry(countrySelected: string) {
        this.countrySelected = countrySelected;
    }
}
